import {
  VERIFY_OTP,
  VERIFY_OTP_SUCCESSFUL,
  VERIFY_OTP_FAILED,
  SEND_MOBILE,
  SEND_MOBILE_SUCCESSFUL,
  SEND_MOBILE_FAILED,
  RESET_VERIFYOTP_ERRORS,
  SEND_FORGETPASSMOBILENO,
  SEND_FORGETPASSMOBILENO_SUCCESSFUL,
  SEND_FORGETPASSMOBILENO_FAILED,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_SUCCESSFUL,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_RESET,
  CHANGE_PROFILE_PASSWORD_START,
  CHANGE_PROFILE_PASSWORD_SUCCESSFUL,
  CHANGE_PROFILE_PASSWORD_FAILED,
  CHANGE_PROFILE_PASSWORD_RESET,
} from "./actionTypes"

const initialState = {
  verifyOtpError: null,
  otpResponseMessage: null,
  loading: false,
  otpVerified: false,
  success: false,
  verifyLoading: false,

}

const otpReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_OTP:
      state = {
        ...state,
        verifyLoading: true,
        success: false,
        verifyOtpError: null,
        otpVerified: false,
      }
      break
    case VERIFY_OTP_SUCCESSFUL:
      console.log(action.payload.message)
      state = {
        ...state,
        verifyLoading: false,
        otpResponseMessage: action.payload.message,
        otpVerified: action.payload.message === 'OTP verified'? true : false,
        success: action.payload.message === 'OTP verified'? true : false,
        // loading:false,
        verifyOtpError: action.payload.message === 'OTP verified'? false : true,
      }
      break
    case VERIFY_OTP_FAILED:
      state = {
        ...state,
        // user: null,
        verifyLoading: false,
        success: false,
       // loading:false,
        verifyOtpError: action.payload,
        otpVerified:false,
      }
      break
    case SEND_MOBILE:
      state = {
        ...state,
        verifyLoading: false,
        loading: true,
        success: false,
        verifyOtpError: null,
        otpResponseMessage: null
      }
      break
    case SEND_MOBILE_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        success: true,
        verifyOtpError: null,
        otpResponseMessage: action.payload.message
      }
      break
    case SEND_MOBILE_FAILED:
      console.log(action.payload)
      state = {
        ...state,
        // user: null,
        loading: false,
        success: false,
        verifyOtpError: action.payload,
      }
      break
    case RESET_VERIFYOTP_ERRORS:
      state = {
        ...state,
        // user: null,
        success: false,
        verifyOtpError: null,
        otpResponseMessage: null,
        otpVerified: false
      }
      break
      case SEND_FORGETPASSMOBILENO:
        state = {
          ...state,
          loading: true,
          success: false,
          verifyOtpError: null,
          otpResponseMessage: null
        }
        break
      case SEND_FORGETPASSMOBILENO_SUCCESSFUL:
        state = {
          ...state,
          loading: false,
          success: true,
          verifyOtpError: null,
          otpResponseMessage: action.payload.message
        }
        break
      case SEND_FORGETPASSMOBILENO_FAILED:
        console.log(action.payload)
        state = {
          ...state,
         
          loading: false,
          success: false,
          verifyOtpError: action.payload,
        }
        break

        case CHANGE_PASSWORD_START:
          return {
            ...state,
            error: null,
            loading: true,
            responseMsg: "",
          }
    
        case CHANGE_PASSWORD_SUCCESSFUL:
          return {
            ...state,
            error: null,
            loading: false,
            responseMsg: action.payload.message,
          }
    
        case CHANGE_PASSWORD_FAILED:
          return {
            ...state,
            loading: false,
            error:action.error.message,
          }
        case CHANGE_PASSWORD_RESET:
          return {
            error: null,
            loading: false,
            responseMsg: "",
          }

          case CHANGE_PROFILE_PASSWORD_START:
            return {
              ...state,
              error: null,
              loading: true,
              responseMsg: "",
            }
      
          case CHANGE_PROFILE_PASSWORD_SUCCESSFUL:
           
            return {
              ...state,
              error: null,
              loading: false,
              responseMsg: action.payload.message,
            }
      
          case CHANGE_PROFILE_PASSWORD_FAILED:
            
            return {
              ...state,
              loading: false,
              error:action.error,
            }
          case CHANGE_PROFILE_PASSWORD_RESET:
            return {
              ...state,
              error: null,
              loading: false,
              responseMsg: "",
            }
  
  

    default:
      return state
  }
  return state
}

export default otpReducer;
